function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.031 9.508l.637-.11v-3.02L6.03 6.27v-.497h1.406v3.625l.637.11V10H6.031v-.492zM7.437 4.69h-.77v-.785h.77v.785z",
  fill: "#181EA9"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  clipRule: "evenodd",
  d: "M7 13A6 6 0 107 1a6 6 0 000 12z",
  stroke: "#181EA9",
  strokeWidth: 0.65
});

function SvgInfo(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMDMxMTcgOS41MDc4MUw2LjY2Nzg5IDkuMzk4NDRWNi4zNzg5MUw2LjAzMTE3IDYuMjY5NTNWNS43NzM0NEg3LjQzNzQyVjkuMzk4NDRMOC4wNzQxNCA5LjUwNzgxVjEwSDYuMDMxMTdWOS41MDc4MVpNNy40Mzc0MiA0LjY5MTQxSDYuNjY3ODlWMy45MDYyNUg3LjQzNzQyVjQuNjkxNDFaIiBmaWxsPSIjMTgxRUE5Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNyAxM0MxMC4zMTM3IDEzIDEzIDEwLjMxMzcgMTMgN0MxMyAzLjY4NjI5IDEwLjMxMzcgMSA3IDFDMy42ODYyOSAxIDEgMy42ODYyOSAxIDdDMSAxMC4zMTM3IDMuNjg2MjkgMTMgNyAxM1oiIHN0cm9rZT0iIzE4MUVBOSIgc3Ryb2tlLXdpZHRoPSIwLjY1Ii8+Cjwvc3ZnPgo=";
export { SvgInfo as ReactComponent };